<app-modal #contactUsModal>
  <div class="modal-content">
    <div class="modal-header border-0">
      <h5 class="modal-title">{{ 'CONTACT_US.TITLE' | translate }}</h5>
      <button type="button"
              class="btn btn-close btn-close-white"
              (click)="contactUsModal.hide()"
              aria-label="Close">
      </button>
    </div>
    <div class="modal-body">
      <form #f="ngForm" (ngSubmit)="f.form.valid && onSubmit()">
        <div class="form-floating mb-3">
          <input
            type="email"
            class="form-control mb-2"
            id="email"
            placeholder="Email"
            #email="ngModel"
            email
            required
            name="email"
            [(ngModel)]="contactUs.email"
            [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
          />
          <label for="email">
            {{ "PROFILE.FORM.PERSONAL_INFO.EMAIL" | translate }}
          </label>
        </div>
        <div *ngIf="f.submitted && email.invalid">
          <span
            *ngIf="email.errors?.['email']"
            class="d-block invalid-feedback xsmall"
          >
            <app-icon class="sm-icon me-2" name="warning"></app-icon>
            {{ "FORM_ERROR.EMAIL_INCORRECT" | translate }}
          </span>
          <span
            *ngIf="email.errors?.['required']"
            class="d-block invalid-feedback xsmall"
          >
            <app-icon class="sm-icon me-2" name="warning"></app-icon>
            {{ "FORM_ERROR.FIELD_REQUIRED" | translate }}
          </span>
        </div>
        <div class="form-floating">
          <textarea
            type="text"
            class="form-control textarea-height"
            id="message"
            placeholder="Message"
            #msg="ngModel"
            minlength="1"
            required
            name="message"
            [(ngModel)]="contactUs.content"
          >
          </textarea>
          <label for="message">{{ "CONTACT_US.MESSAGE" | translate }}</label>
        </div>
        <div *ngIf="f.submitted && email.invalid">
            <span
              *ngIf="email.errors?.['required']"
              class="d-block invalid-feedback xsmall"
            >
              <app-icon class="sm-icon me-2" name="warning"></app-icon>
              {{ "FORM_ERROR.FIELD_REQUIRED" | translate }}
            </span>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary rounded-pill px-3">
            {{ "BUTTON.SEND" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</app-modal>
